<template>
  <div class="fantan-game-result">
    <div class="total-result">Total: {{ totalResultCounter }}</div>
    <div class="fantan-trend">
      <Row type="flex" justify="space-around">
        <Col class="fantan-trend-lot-col" v-for="n in 18" :key="n">
          <Row v-for="m in 4" :key="m">
            <div
              ref="fantan-trend-lot-cell"
              class="fantan-trend-lot-cell"
              v-if="(((n-1)*4) + m) <= totalResult"
              :style="`animation-delay:${(((n-1)*4) + m) * 0.1}s`"
            ></div>
            <div class="fantan-trend-lot-cell-neg" v-else></div>
          </Row>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import { TimelineMax } from "gsap";
export default {
  props: ["gameData", "drawResult", "game", "gameCode", "gameId"],
  components: {
    Row,
    Col,
  },
  data() {
    return {
      totalResult: 0,
      totalResultCounter: 0,
    };
  },
  methods: {
    addResult() {
      this.totalResultCounter++;
      setTimeout();
    },
    animationEnd() {
      this.$emit("on-animation-end");
    },
  },
  watch: {
    drawResult() {
      // console.log(this.$refs);
      this.totalResult = 0;
      this.totalResultCounter = 0;

      // while (this.totalResultCounter != this.drawResult.draw_result) {
      //   setTimeout(() => {
      //     this.totalResultCounter++;
      //   }, 100);
      // }
    },
  },
  mounted() {
    this.totalResult = this.gameData.prev.draw_result;
    this.totalResultCounter = this.gameData.prev.draw_result;
  },
};
</script>

<style lang="scss" scoped>
.fantan-game-result {
  height: 142px;
  width: 100%;
}

.total-result {
  width: 100%;
  padding: 5px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 25px;
  background-color: darkgray;
}

.fantan-trend {
  padding: 10px 5px 10px 5px;
}

.fantan-trend-lot-cell {
  background: grey;
  box-shadow: 0px 1px 0px #00000029;
  border-radius: 100px;
  width: 13px;
  height: 13px;
  border-radius: 100px;
  margin-top: 6px;
  border-color: 2px solid black;
  animation: pop 0.1s linear 1;
  animation-fill-mode: forwards;
  //   animation-delay: 3s;
}

.fantan-trend-lot-cell-neg {
  background: grey;
  box-shadow: 0px 1px 0px #00000029;
  border-radius: 100px;
  width: 13px;
  height: 13px;
  border-radius: 100px;
  margin-top: 6px;
}

@keyframes pop {
  0% {
    transform: scale(1.4);
  }
  100% {
    // background: white;
    background: transparent linear-gradient(163deg, #ffffff 0%, #9a9a9a 100%);
    box-shadow: 0px 1px 0px #00000029;
  }
}
</style>

